const DEPLOYMENT_JSON_URL = `${window.location.origin}/deployment.json`

interface DeploymentData {
    build: string
}

export default async function getCurrentWebAppVersion(
    signal?: AbortSignal,
): Promise<DeploymentData | null> {
    try {
        // Deployment metadata is public static content, independent of LOS auth.
        // Same-origin credentials allow the browser to honor Clear-Site-Data.
        const response = await fetch(DEPLOYMENT_JSON_URL, {
            cache: 'no-store',
            credentials: 'same-origin',
            signal,
        })

        if (!response.ok) return null

        const data: unknown = await response.json()

        if (
            typeof data !== 'object' ||
            data === null ||
            !('build' in data) ||
            typeof data.build !== 'string' ||
            data.build.trim() === ''
        ) {
            return null
        }

        return { build: data.build.trim() }
    } catch {
        // A failed check must leave the current workflow usable until a retry.
        return null
    }
}
